import { Aggregates } from "hfapi/hff";

class Form extends Aggregates.Form {

}

export default Form;
